import React from 'react';
import '../../Styles/Home.css'
import { MdOutlineWavingHand } from 'react-icons/md';
import { IoDownload } from 'react-icons/io5';
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs';
import resume from '../../assets/resume.pdf'
import useProjects from '../../hooks/useProjects';
import { HiDownload } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import RotatingCirclePath from '../RotatingCirclePath/RotatingCirclePath';
const HeroSection = () => {
    const { projects } = useProjects()
    const navigate = useNavigate()
    // console.log(projects[1]?.clientRepo)
    const ranProIndex = Math.floor(Math.random() * projects?.length);
    console.log(projects[ranProIndex])
    const dynamicURL = `project/${projects[ranProIndex]?.projectName.replace(/ /g, "-")}`
    return (
        <>
            <div className='container__full home__container container'>
                <div className="">
                    <h4 className='faded__heading'>
                        {/* <MdOutlineWavingHand color="black" style={{ fontSize: "40px", marginRight: "1rem" }} /> */}
                        HELLO THERE, MY NAME IS <span className='gradient__animation' style={{ marginLeft: "0.3rem" }}> ROKAN</span></h4>
                    <h1 className='primary__heading'>I’m a Junior
                        <br /><span className="gradient__animation">Web Developer</span> from
                        <br />Bangladesh!</h1>
                    <div className="div__line"></div>
                    <p>I craft <b>high-performing</b>, beautiful websites that are <b>conversion-focused, brand-accurate</b>, & people-friendly.</p>
                </div>
                <div className="hero__carosel">
                    {/* <img src="https://cdn.sanity.io/images/72m24xcw/production/167bb166684004ea63dfc268fa32e3d99a403f56-1600x1200.jpg?rect=0,0,1599,1200&w=1366&h=1025&auto=format" alt="" /> */}
                    <article className='featured__project__card'>
                        <div id='projectImg' className='project__thumb' style={{ position: "relative" }}>
                            <img onClick={() => navigate(dynamicURL)} src={projects[ranProIndex]?.projectThumbnail} alt="" />
                        </div>
                    </article>
                    <RotatingCirclePath />
                </div>
                <button style={{ position: "relative" }} onClick={() => window.location.href = resume} className='hero__button'>
                    <span style={{ marginLeft: "2rem" }}><BsFillFileEarmarkPdfFill style={{ position: "absolute", fontSize: "25px", left: "16px", top: "12px" }} />DOWNLOAD MY RESUME</span>
                    <span style={{ padding: "10px", borderRadius: "90%", backgroundColor: "#000" }}>
                        <HiDownload style={{ fontSize: "20px", fontWeight: "600", color: "white" }} />
                    </span>
                </button>
                {/* <button style={{ position: "relative" }} onClick={() => window.location.href = resume} className='hero__button'><HiDownload style={{ paddingBottom: "1px", marginRight: "0.5rem", fontSize: "22px", fontWeight: "600", position: "absolute", right: "0" }} />DOWNLOAD MY RESUME</button> */}
            </div>
        </>
    );
};

export default HeroSection;